import bugsnagClient from '@evolve/BugsnagIntegration'

export function notifyError (error, metaData, options = {}) {
  bugsnagClient.notify(error, { metaData, ...options })
  console.error(error)
}
